// JavaScript Document


function initPatternHeading() {

    const patternHeadingBlocks = document.querySelectorAll('.pattern-heading-block');

    patternHeadingBlocks.forEach(patternHeadingBlock => {

        let headingWidth = patternHeadingBlock.querySelector('.pattern-heading').clientWidth;
        const patternHeadingEinleitung =  patternHeadingBlock.querySelector('.pattern-heading-einleitung');

        setEinleitungWidth(headingWidth);

        function setEinleitungWidth(width) {

          if (patternHeadingEinleitung) {
            patternHeadingEinleitung.style.width=width+'px';
          }

        }


        window.addEventListener('resize', function(event){
            headingWidth = patternHeadingBlock.querySelector('.pattern-heading').clientWidth;

            setEinleitungWidth(headingWidth);

          });





    });



}
